// @flow weak
import React, { Component } from "react";
import {
  Switch,
  Route
} from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import { Provider } from "react-redux";
import configureStore from "./redux/store/configureStore";
import { history } from "./redux/store/configureStore";
import App from "./containers/app";
import Authorization from "./routes/Authorization";
import InitialSetup from "./InitialSetup.js";
import ScrollTop                from './components/scrollToTop/ScrollToTop';
import _ from "lodash";
import Login from "./views/admin/login";
import PageNotFound from "./views/pageNotFound";
import ForgotPassword from "./views/admin/forgotPassword";
import ResetPassword from "./views/admin/resetPassword";
// #region flow types
type Props = any;
type State = any;

// #endregion

const store = configureStore();
const Admin = Authorization(["admin"]);
const forgotUsers = Authorization(["admin", "merchant"]);
const SuperAdmin = Authorization(["superadmin", "admin"]);
class Root extends Component {
  renderInitialView() {
    return  <InitialSetup/>
  }

  render() {
    const user = {};
    return (
      <Provider store={store}>
       <ConnectedRouter history={history}>
            <ScrollTop>
              <Switch>
                <Route exact path="/" component={Login} />
                <Route exact path="/forgot" component={ForgotPassword} />
                <Route exact path="/resetpassword/:token?" component={ResetPassword} />
                <App />
                <Route component={PageNotFound} />
                {/* <PrivateRoute path="/protected" component={ProtectedConnected} /> */}
              </Switch>
            </ScrollTop>
          </ConnectedRouter>
      </Provider>
    );
  }
}


export default Root;



// WEBPACK FOOTER //
// ./src/app/Root.js